module.exports = __webpack_public_path__ + "static/media/RLC_8418a.6cc05397.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/kukenan/RLC_8418a.JPG
// module id = 101
// module chunks = 0